import { render, staticRenderFns } from "./CopyText.vue?vue&type=template&id=4160715b&scoped=true&"
import script from "./CopyText.vue?vue&type=script&lang=js&"
export * from "./CopyText.vue?vue&type=script&lang=js&"
import style0 from "./CopyText.vue?vue&type=style&index=0&id=4160715b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160715b",
  null
  
)

export default component.exports